import React from 'react';
import { Alert } from '@guildeducationinc/recess';

interface Props {
	display: boolean;
	destinationLink?: string;
	errorCopy: string;
	actionCopy?: string;
}

export const ErrorToast: React.FC<Props> = props => {
	const { destinationLink, errorCopy, actionCopy, display } = props;
	return (
		<Alert display={display} hideClose={true} type='danger'>
			<Alert.Content>{errorCopy}</Alert.Content>
			<Alert.Action className='cursor--pointer' href={destinationLink}>
				{actionCopy}
			</Alert.Action>
		</Alert>
	);
};
